
import Vue from "vue";
import store from "@/store";
import { IApplicationStatus } from "@/store/applications/types";
import { ROUTE_NAMES } from "@/routes";
import { mapState } from "vuex";
import { IRootState } from "@/store/types";
import { COMPLETED_DEFAULT_STATUSES } from "@/constants/applicationStatuses";
import { APPLICATION } from "@/store/applications";

export default Vue.extend({
  data() {
    return {
      isLoading: false,
      headers: [
        { text: "Id", value: "id" },
        { text: "Applicant name", value: "fullName" },
        { text: "Business name", value: "businessName", sortable: false },
        { text: "Created date", value: "createdDate" },
        { text: "Updated date", value: "updatedDate" },
        { text: "Status", value: "status" }
      ],
      applicationStatuses: COMPLETED_DEFAULT_STATUSES
    };
  },
  computed: {
    pagination: {
      get() {
        return store.state.application.dataTables.completed.pagination;
      },
      set(value: string) {
        this.$store.commit(
          APPLICATION.NS(APPLICATION.MUTATIONS.SET_COMPLETED_APPLICATIONS_PAGINATION),
          value
        );
      }
    },
    statusFilters: {
      get(): any {
        return (
          store.state.application.dataTables.completed.statusFilters ||
          this.applicationStatuses
        );
      },
      set(value: string) {
        this.$store.commit(
          APPLICATION.NS(
            APPLICATION.MUTATIONS.SET_COMPLETED_DATA_TABLE_STATUS_FILTERS
          ),
          value
        );
      }
    },
    ...mapState({
      completedApplications: (state: IRootState) =>
        state.application.completedApplicationsList,
      totalApplications: (state: IRootState) =>
        state.application.completedApplicationsListTotal
    }),
    route: () => ROUTE_NAMES.APPLICATION_DETAIL
  },
  methods: {
    async onSearch() {
      this.isLoading = true;

      await this.$store.dispatch(
        APPLICATION.NS(APPLICATION.ACTIONS.LOAD_COMPLETED_APPLICATION_LIST),
        {
          statuses: this.statusFilters,
          pagination: this.pagination
        }
      );

      this.isLoading = false;
    },
    async onStatusChange(statuses: any) {
      this.pagination.page = 1;
      await this.onSearch();
    },
    goToDetails(id: any) {
      this.$router.push({
        name: ROUTE_NAMES.APPLICATION_DETAIL,
        params: { id }
      });
    }
  }
});
